import { Sites } from '@ps/platform-message-framework/common/Sites';
import { FeatureFlag } from '@ps/web-core-enums';
import { useFeature } from '@ps/web-core-store';
import classNames from 'clsx';
import React from 'react';
import { useForm } from 'react-final-form';
import { useSelector } from 'react-redux';

import useWizardContext from '@swf/core/hooks/useWizardContext';
import useWizardExit from '@swf/core/hooks/useWizardExit';
import { select } from '@swf/core/store';

import Prompt from '../../../../../Prompt/Prompt';
import TransitionProgressPrompt from '../../../../../TransitionProgressPrompt/TransitionProgressPrompt';

import {
  TXTCLI_Explore_PokerStars,
  TXTCLI_Verify_My_Account,
  TXTWCL_Continue_to_deposit,
  TXTWCL_Next_upXX,
  TXTWCL_Thank_You
} from './Celebration.messages.json';
import { promptButton, promptButtons } from './Celebration.scss';
import Base from './components/Base/Base';
import ES from './components/ES/ES';
import FR from './components/FR/FR';
import RO from './components/RO/RO';

export const getContent = (siteId: Sites) => {
  switch (siteId) {
    case Sites.ROM || Sites.ITA:
      return <RO />;
    case Sites.FRA:
      return <FR />;
    case Sites.SPA:
      return <ES />;
    default:
      return <Base />;
  }
};

const Celebration: React.FC = () => {
  const form = useForm();
  const exploreCTAEnabled = useFeature(FeatureFlag.SwcExploreCta);
  const depositReverseCTAVerify = useFeature(FeatureFlag.DepositReverseCTAVerify);
  const isNewTransitionEnabled = useFeature(FeatureFlag.SwcSignupRmfEcoEransitionTwo);
  const siteId = useSelector(select.cms.getSiteId);
  const isSpain = siteId === Sites.SPA;

  const content = getContent(siteId);
  const exitWizard = useWizardExit();
  const isEmbedded = useSelector(select.device.isEmbedded);

  const {
    data: { rmfPassed }
  } = useWizardContext();

  const getPrimaryButtonTitle = () => {
    if (depositReverseCTAVerify) {
      return TXTCLI_Verify_My_Account;
    }
    return TXTWCL_Continue_to_deposit;
  };

  const getSecondaryButtonButtonTitle = () => {
    if (depositReverseCTAVerify) {
      return TXTWCL_Continue_to_deposit;
    }
    return TXTCLI_Verify_My_Account;
  };

  const onButtonClick = () => {
    if (isEmbedded) {
      window.starsweb?.app?.execute('docverify');
      window.close();
      return;
    }
    form.submit();
  };

  return content && rmfPassed && !isNewTransitionEnabled ? (
    <Prompt
      noCloseButton
      variant="celebration"
      title={{ translation: TXTWCL_Thank_You }}
      secondaryTitle={isSpain ? undefined : { translation: TXTWCL_Next_upXX }}
      primaryButton={{
        translation: getPrimaryButtonTitle()
      }}
      secondaryButton={{
        translation: getSecondaryButtonButtonTitle()
      }}
      {...(!depositReverseCTAVerify && { onPrimaryButtonClick: () => onButtonClick() })}
      {...(depositReverseCTAVerify && { onSecondaryButtonClick: () => form.submit() })}
      classes={{ buttons: classNames(promptButtons, promptButton) }}
      {...(exploreCTAEnabled && {
        showLinkButton: true,
        onLinkButton: exitWizard,
        linkButton: { translation: TXTCLI_Explore_PokerStars }
      })}
    >
      {content}
    </Prompt>
  ) : content && rmfPassed && isNewTransitionEnabled ? (
    <TransitionProgressPrompt
      title={{ translation: TXTWCL_Thank_You }}
      primaryButton={{
        translation: getPrimaryButtonTitle()
      }}
      secondaryButton={{
        translation: getSecondaryButtonButtonTitle()
      }}
      {...(!depositReverseCTAVerify && { onPrimaryButtonClick: () => form.submit() })}
      {...(depositReverseCTAVerify && { onSecondaryButtonClick: () => form.submit() })}
    >
      {content}
    </TransitionProgressPrompt>
  ) : null;
};

export default Celebration;
